import './ProductComparisonError.less';
import Button from '../../button/Button';
import { useTranslation } from '../../../hooks/useTranslation';

export type ProductComparisonErrorProps = {
    onRetryClick?: () => void;
};

const ProductComparisonError = ({
    onRetryClick
}: ProductComparisonErrorProps) => {
    const { t } = useTranslation();
    return (
        <div className={`bri-ProductComparisonError`}>
            <div className={`bri-ProductComparisonError-main`}>
                {t('GENERIC_ERROR_TITLE')}
            </div>
            <div className={`bri-ProductComparisonError-secondary`}>
                {t('GENERIC_ERROR_SUBTITLE')}
            </div>
            {onRetryClick && (
                <Button variant="link" onClick={onRetryClick}>
                    {t('GENERIC_ERROR_RETRY_BUTTON_LABEL')}
                </Button>
            )}
        </div>
    );
};

export default ProductComparisonError;
